module.exports = __webpack_public_path__ + "Roboto-bold.ee7b96fa85d8fdb8c126409326ac2d2b.hashedasset.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/resources/fonts/Roboto/Roboto-bold.ttf
// module id = 438
// module chunks = 8